(function () {
  'use strict';

  const ATTRIBUTE_KEY = 'bulk_order';
  const WEIGHT_LIMIT_GRAMS = 30000; // 30 kg

  let updateTimer = null;
  let isUpdating = false;
  let lastProcessedWeight = null;

  /**
   * Get the current Shopify cart
   */
  async function getCart() {
    const response = await fetch(
      window.Shopify.routes.root + 'cart.js',
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        },
        credentials: 'same-origin'
      }
    );

    if (!response.ok) {
      throw new Error('Unable to fetch cart');
    }

    return response.json();
  }

  /**
   * Update the bulk_order cart attribute
   */
  async function updateBulkOrderAttribute(isBulkOrder, cart) {
    const currentValue = cart.attributes
      ? cart.attributes[ATTRIBUTE_KEY]
      : null;

    const newValue = isBulkOrder ? 'true' : '';

    // Nothing to change
    if (currentValue === newValue) {
      return;
    }

    if (isUpdating) {
      return;
    }

    isUpdating = true;

    try {
      const response = await fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            attributes: {
              [ATTRIBUTE_KEY]: newValue
            }
          })
        }
      );

      if (!response.ok) {
        throw new Error('Unable to update cart attribute');
      }

      const updatedCart = await response.json();

      console.log(
        '[Bulk Order] Attribute updated:',
        updatedCart.attributes
      );

    } catch (error) {
      console.error(
        '[Bulk Order] Failed to update cart attribute:',
        error
      );
    } finally {
      isUpdating = false;
    }
  }

  /**
   * Check cart weight and update attribute
   */
  async function checkBulkOrder() {
    try {
      const cart = await getCart();

      const totalWeight = Number(cart.total_weight || 0);

      // Prevent unnecessary processing
      if (lastProcessedWeight === totalWeight) {
        return;
      }

      lastProcessedWeight = totalWeight;

      const isBulkOrder = totalWeight > WEIGHT_LIMIT_GRAMS;

      console.log(
        '[Bulk Order] Weight:',
        (totalWeight / 1000).toFixed(2) + ' kg',
        '| Bulk:',
        isBulkOrder
      );

      await updateBulkOrderAttribute(
        isBulkOrder,
        cart
      );

    } catch (error) {
      console.error(
        '[Bulk Order] Cart check failed:',
        error
      );
    }
  }

  /**
   * Debounced cart check
   */
  function scheduleCheck() {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      checkBulkOrder();
    }, 300);
  }

  /**
   * Initial check
   */
  document.addEventListener('DOMContentLoaded', function () {
    checkBulkOrder();
  });

  /**
   * Detect Shopify cart AJAX events
   */
  document.addEventListener(
    'shopify:cart:update',
    scheduleCheck
  );

  document.addEventListener(
    'shopify:cart:change',
    scheduleCheck
  );

  document.addEventListener(
    'shopify:cart:add',
    scheduleCheck
  );

  /**
   * Catch fetch-based cart updates used by
   * Shopify themes and apps.
   */
  const originalFetch = window.fetch;

  window.fetch = function () {
    const args = arguments;
    const url = args[0];

    const requestUrl =
      typeof url === 'string'
        ? url
        : url && url.url
          ? url.url
          : '';

    const fetchPromise = originalFetch.apply(
      this,
      args
    );

    if (
      requestUrl.includes('/cart/add') ||
      requestUrl.includes('/cart/change') ||
      requestUrl.includes('/cart/update') ||
      requestUrl.includes('/cart/clear')
    ) {
      fetchPromise.then(function () {
        scheduleCheck();
      }).catch(function () {});
    }

    return fetchPromise;
  };

  /**
   * Catch XMLHttpRequest-based cart updates
   * used by some themes/apps.
   */
  const originalOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function (
    method,
    url
  ) {
    this._bulkOrderRequestUrl = url;

    return originalOpen.apply(
      this,
      arguments
    );
  };

  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.send = function () {
    const xhr = this;

    if (
      typeof xhr._bulkOrderRequestUrl === 'string' &&
      (
        xhr._bulkOrderRequestUrl.includes('/cart/add') ||
        xhr._bulkOrderRequestUrl.includes('/cart/change') ||
        xhr._bulkOrderRequestUrl.includes('/cart/update') ||
        xhr._bulkOrderRequestUrl.includes('/cart/clear')
      )
    ) {
      xhr.addEventListener(
        'load',
        function () {
          scheduleCheck();
        }
      );
    }

    return originalSend.apply(
      this,
      arguments
    );
  };

})();